module.exports = __webpack_public_path__ + "img/lg_ring_y_c_1_null.837be26a.png";